export const RTL: string = 'RTL'
